// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralState } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/State/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useCollateralState: () => UseQueryResult<
  TemplateContract<CollateralState>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOptions({
    select: (data: TemplateContract<CollateralState>[]) =>
      data.filter((d) => d.payload.operator === operator),
    queryKey: ['queryCollateralState', operator],
    enabled: !!operator,
    queryFn: async (_, options) => {
      return ledgerApi.query(options, CollateralState);
    },
  });
};

export default useCollateralState;
